export const JPEG_LOGO_TYPE = "image/jpeg";
export const PNG_LOGO_TYPE = "image/png";
export const SVG_LOGO_TYPE = "image/svg+xml";
export const GIF_LOGO_TYPE = "image/gif";

export const SHOP_LOGO_TYPE = {
  [JPEG_LOGO_TYPE]: {
    type: JPEG_LOGO_TYPE,
    className: "jpgLogoType",
  },
  [PNG_LOGO_TYPE]: {
    type: PNG_LOGO_TYPE,
    className: "pngLogoType",
  },
  [SVG_LOGO_TYPE]: {
    type: SVG_LOGO_TYPE,
    className: "svgLogoType",
  },
  [GIF_LOGO_TYPE]: {
    type: GIF_LOGO_TYPE,
    className: "gifLogoType",
  },
};
